export enum StageSizeType {
  CLOSED,
  SMALL,
  MEDIUM,
  FULL_SCREEN,
}
